import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {
  IsItDownServiceStatus,
  IsItDownServiceStatusPill,
  IsItDownServiceStatusPillHeader,
} from "@/lib/types/isitdown.ts";

import styles from "./IsItDownStatusBadge.module.scss";

type IsItDownStatusBadgeVariant = "header" | "default";

interface IsItDownStatusBadgeProps {
  serviceStatus: IsItDownServiceStatus;
  variant?: IsItDownStatusBadgeVariant;
}

const pillStatusMap = {
  header: IsItDownServiceStatusPillHeader,
  default: IsItDownServiceStatusPill,
};

export const IsItDownStatusBadge = ({serviceStatus, variant = "default"}: IsItDownStatusBadgeProps) => {
  const pillStatus = pillStatusMap[variant][serviceStatus];

  return (
    <div className={`${styles.container}`}>
      <StatusPill
        type="checks"
        variant="textAndIcon"
        status={pillStatus}
        mobileStatus={variant === "default" && pillStatus === PillStatus.OUTAGE_REPORTED ? PillStatus.DOWN : undefined}
      />
      {serviceStatus === IsItDownServiceStatus.MAINTENANCE && (
        <StatusPill type="checks" variant="icon" status={PillStatus[serviceStatus]} />
      )}
    </div>
  );
};
